import { Component, OnInit } from '@angular/core';
import { registerLocaleData } from '@angular/common';

import localeDe from '@angular/common/locales/de';
import { RouterOutlet } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import {
  matTitle,
  matSubtitles,
  matPlace,
  matLink,
  matEvent,
  matArrowDownward,
  matLocalLibrary,
  matGroup,
  matContactMail,
  matOpenInNew,
} from '@ng-icons/material-icons/baseline';
import {
  ionMailOutline,
  ionLogoSlack,
  ionLogoDiscord,
  ionLogoFacebook,
  ionLogoInstagram,
} from '@ng-icons/ionicons';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
  viewProviders: [
    provideIcons({
      matTitle,
      matSubtitles,
      matPlace,
      matLink,
      matEvent,
      matArrowDownward,
      matLocalLibrary,
      matGroup,
      matContactMail,
      matOpenInNew,
      ionMailOutline,
      ionLogoSlack,
      ionLogoDiscord,
      ionLogoFacebook,
      ionLogoInstagram,
    }),
  ],
})
export class AppComponent implements OnInit {
  ngOnInit() {
    registerLocaleData(localeDe, 'de');
  }
}
